import React from 'react';

interface MainContentProps {
  children: React.ReactNode;
}

const MainContent: React.FC<MainContentProps> = ({ children }) => {
  return (
    <main
      className="flex-1 overflow-y-auto focus:outline-none"
      style={{ backgroundColor: 'var(--color-surface-content)' }}
    >
      {children}
    </main>
  );
};

export default MainContent;
